// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: sBn4nuVzZj
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import NavBar2 from "../../NavBar2"; // plasmic-import: lLCcoonTe6o/component
import Form from "../../Form"; // plasmic-import: N4buk5LIp3R/component
import ContactDiv from "../../ContactDiv"; // plasmic-import: K63AXAYlTq/component
import Footer from "../../Footer"; // plasmic-import: EvRh7yjThy6/component
import { useScreenVariants as useScreenVariantsrrBukHdQcoc } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: rrBukHDQcoc/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicCommunityPage.module.css"; // plasmic-import: sBn4nuVzZj/css
import DownChevronSvgrepoComSvgIcon from "./icons/PlasmicIcon__DownChevronSvgrepoComSvg"; // plasmic-import: VsWatNrBzSXb/icon
import gephipng65428Da8A28284D9De35PngJ3W27WepDyL from "./images/gephipng65428Da8A28284D9De35Png.png"; // plasmic-import: j3W27wepDyL_/picture
import studentpng2C2710Ff1739Cd0Bc011EPngGrvxEzRUe6MC from "./images/studentpng2C2710Ff1739Cd0Bc011EPng.png"; // plasmic-import: GrvxEzRUe6mC/picture

createPlasmicElementProxy;

export const PlasmicCommunityPage__VariantProps = new Array();

export const PlasmicCommunityPage__ArgProps = new Array();

const $$ = {};

function PlasmicCommunityPage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsrrBukHdQcoc()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root
          )}
        >
          <NavBar2
            data-plasmic-name={"navBar2"}
            data-plasmic-override={overrides.navBar2}
            className={classNames("__wab_instance", sty.navBar2)}
          />

          <div
            data-plasmic-name={"hero"}
            data-plasmic-override={overrides.hero}
            className={classNames(projectcss.all, sty.hero)}
          >
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.columns__jeeql)}
            >
              <div className={classNames(projectcss.all, sty.column___1Reei)}>
                <div className={classNames(projectcss.all, sty.freeBox__li6SB)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__dCqqU
                    )}
                  >
                    {
                      "Encourage Innovation, Broaden the Horizons of What's Possible"
                    }
                  </div>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___6TP3Z
                    )}
                  >
                    {
                      "Basil Community is an open data initiative which aims to foster the use of ethical, sustainable data practices among the next generation of students, researchers, and small businesses across the world. We help pioneers interested in the potential of community-generated data to explore consumer patterns through their research as well as enable small businesses to make day-to-day decisions easier."
                    }
                  </div>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.column__qhxCn)}>
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__nu0Tq)}
                  displayHeight={
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? "auto"
                      : "auto"
                  }
                  displayMaxHeight={"none"}
                  displayMaxWidth={
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? "90%"
                      : "100%"
                  }
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? "100%"
                      : "500px"
                  }
                  loading={"lazy"}
                  src={{
                    src: gephipng65428Da8A28284D9De35PngJ3W27WepDyL,
                    fullWidth: 612,
                    fullHeight: 612,
                    aspectRatio: undefined
                  }}
                />
              </div>
            </Stack__>
            <div className={classNames(projectcss.all, sty.freeBox__eBEbA)}>
              <DownChevronSvgrepoComSvgIcon
                data-plasmic-name={"svg"}
                data-plasmic-override={overrides.svg}
                className={classNames(projectcss.all, sty.svg)}
                role={"img"}
              />
            </div>
          </div>
          <div
            data-plasmic-name={"smallBiz"}
            data-plasmic-override={overrides.smallBiz}
            className={classNames(projectcss.all, sty.smallBiz)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__hjLPc)}>
              <div className={classNames(projectcss.all, sty.columns__qawIt)}>
                <div className={classNames(projectcss.all, sty.column__nxey7)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__hQqox)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__oPwTt
                      )}
                    >
                      {"SMB Program"}
                    </div>
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__uNe2O
                      )}
                    >
                      {"We Help Your Business Grow"}
                    </div>
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__cAdPj
                      )}
                    >
                      {
                        "Our team wants to make a difference. We work with SMEs and help them utilise analytics about their own businesses to better understand consumers. \n\nPlease do not hesitate to reach out regarding free insights about your business as well as Basil Community's free Point of Sales AI prediction tool. "
                      }
                    </div>
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.column__mnDht)}>
                  <Form
                    data-plasmic-name={"form"}
                    data-plasmic-override={overrides.form}
                    className={classNames("__wab_instance", sty.form)}
                    transparentBackground={true}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"academic"}
            data-plasmic-override={overrides.academic}
            className={classNames(projectcss.all, sty.academic)}
          >
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.columns__qJhmS)}
            >
              <div className={classNames(projectcss.all, sty.column__vuVmN)}>
                <div className={classNames(projectcss.all, sty.freeBox__tLv3)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__rVhOw
                    )}
                  >
                    {"Academic Program"}
                  </div>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___4DCm3
                    )}
                  >
                    {
                      "The Basil Community Data Sharing Program offers free datasets to researchers and students, aiming to bridge the gap between academic learning and real-world applications of user-generated data. This initiative was created in response to the growing need for meaningful projects that harness the power of such data, a crucial aspect of today's digital landscape.\n\nOur mission is to make the Basil Community a hub for ethical research, where students and professionals alike can gain hands-on experience with these datasets, driving ethical and responsible innovation."
                    }
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__cz6V4)}
                  >
                    <PlasmicLink__
                      data-plasmic-name={"greenButton"}
                      data-plasmic-override={overrides.greenButton}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.greenButton
                      )}
                      href={`/contact-us`}
                      platform={"react"}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__aguFp
                        )}
                      >
                        {"Contact Us"}
                      </div>
                    </PlasmicLink__>
                  </div>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.column__mGct2)}>
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__aXIb6)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"400px"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loading={"lazy"}
                  src={{
                    src: studentpng2C2710Ff1739Cd0Bc011EPngGrvxEzRUe6MC,
                    fullWidth: 1288,
                    fullHeight: 883,
                    aspectRatio: undefined
                  }}
                />
              </div>
            </Stack__>
          </div>
          <ContactDiv
            data-plasmic-name={"contactDiv"}
            data-plasmic-override={overrides.contactDiv}
            className={classNames("__wab_instance", sty.contactDiv)}
          />

          <div className={classNames(projectcss.all, sty.freeBox__wDlwi)}>
            <Footer
              data-plasmic-name={"footer"}
              data-plasmic-override={overrides.footer}
              className={classNames("__wab_instance", sty.footer)}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "navBar2",
    "hero",
    "svg",
    "smallBiz",
    "form",
    "academic",
    "greenButton",
    "contactDiv",
    "footer"
  ],

  navBar2: ["navBar2"],
  hero: ["hero", "svg"],
  svg: ["svg"],
  smallBiz: ["smallBiz", "form"],
  form: ["form"],
  academic: ["academic", "greenButton"],
  greenButton: ["greenButton"],
  contactDiv: ["contactDiv"],
  footer: ["footer"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCommunityPage__ArgProps,
          internalVariantPropNames: PlasmicCommunityPage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCommunityPage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCommunityPage";
  } else {
    func.displayName = `PlasmicCommunityPage.${nodeName}`;
  }
  return func;
}

export const PlasmicCommunityPage = Object.assign(
  // Top-level PlasmicCommunityPage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    navBar2: makeNodeComponent("navBar2"),
    hero: makeNodeComponent("hero"),
    svg: makeNodeComponent("svg"),
    smallBiz: makeNodeComponent("smallBiz"),
    form: makeNodeComponent("form"),
    academic: makeNodeComponent("academic"),
    greenButton: makeNodeComponent("greenButton"),
    contactDiv: makeNodeComponent("contactDiv"),
    footer: makeNodeComponent("footer"),
    // Metadata about props expected for PlasmicCommunityPage
    internalVariantProps: PlasmicCommunityPage__VariantProps,
    internalArgProps: PlasmicCommunityPage__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "Basil Labs Community",
      description: "Where Your Consumers Go And What They Value",
      ogImageSrc:
        "https://site-assets.plasmic.app/b553962ca476d3e7588b5978e42c96cf.png",
      canonical: ""
    }
  }
);

export default PlasmicCommunityPage;
/* prettier-ignore-end */
